//  A reusable modal component for confirmation dialogs.
const ResetConfirmationModal = ({ show, onConfirm, onCancel }) => {
    if (!show) {
      return null;
    }
  
    return (
      <div className="fixed inset-0 bg-gray-900 bg-opacity-70 flex items-center justify-center z-50">
        <div className="text-gray-800 bg-cyan-200 hover:bg-cyan-300 transition-all duration-300 px-4 py-2 rounded-xl shadow-lg  max-w-sm w-full mx-4">
          <h3 className="text-xl font-bold mb-2">Confirm Reset</h3>
          <p className="mb-4">Are you sure you want to reset the form? All entered data will be lost.</p>
          <div className="flex justify-end space-x-4">
            <button
              onClick={onCancel}
              className="px-4 py-2 rounded-xl font-semibold text-gray-800 bg-gray-300 hover:bg-gray-400 transition-all duration-300"
            >
              No, Keep Editing
            </button>
            <button
              onClick={onConfirm}
              className="px-4 py-2 rounded-xl font-semibold text-white bg-red-600 hover:bg-red-700 transition-all duration-300"
            >
              Yes, Reset
            </button>
          </div>
        </div>
      </div>
    );
  };
  export default ResetConfirmationModal;